import * as React from 'react'

function SvgAuthenticationMobileHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 376 409" fill="none" {...props}>
      <path
        d="M375.403.385v408.494H.479V161.614C238.18 96.004 375.403.384 375.403.384z"
        fill="url(#prefix__paint0_radial_authentication_mobile_hero_bg)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_authentication_mobile_hero_bg"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(82.035 288.688 -61.338) scale(1017.07 2151.38)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgAuthenticationMobileHeroBG
